// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2db6bfb9","513":"7cb81a61","703":"1f66a37f","787":"15f1ec6a"}[chunkId] + ".chunk.js";
};